import { Navigate, Route, Routes } from "react-router-dom";
import { domAnimation, LazyMotion, MotionConfig } from "motion/react";
import { PublicTool } from "./pages/PublicTool";
import { PrivacyPage } from "./pages/PrivacyPage";
import { AdminLoginPage } from "./pages/admin/AdminLoginPage";
import { AdminSubmissionsPage } from "./pages/admin/AdminSubmissionsPage";
import { AdminSubmissionDetailPage } from "./pages/admin/AdminSubmissionDetailPage";
import { AdminRoute } from "./pages/admin/AdminRoute";
import { ReviewModeBanner } from "./components/ReviewModeBanner";

export default function App() {
  return (
    <MotionConfig reducedMotion="user">
    <LazyMotion features={domAnimation} strict>
      <ReviewModeBanner />
      <Routes>
        <Route path="/" element={<PublicTool />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<Navigate to="/admin/submissions" replace />} />
        <Route element={<AdminRoute />}>
          <Route path="/admin/submissions" element={<AdminSubmissionsPage />} />
          <Route path="/admin/submissions/:id" element={<AdminSubmissionDetailPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </LazyMotion>
    </MotionConfig>
  );
}
